import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type C5Transaction, porfolios_columns } from "./columns";
import {
  type FilterC5TransactionsSchema,
  FilterC5Transactions,
} from "./filter";

const client = Clients.C5;
const table_name = Tables.C5_TRANSACTIONS;

export const C5TransactionsTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<C5Transaction>({
    client,
    table_name,
    resourceLabel: "Transactions",
  });

  return (
    <>
      <Table<C5Transaction, FilterC5TransactionsSchema>
        label="Transactions"
        client={client}
        table_name={table_name}
        columns={porfolios_columns}
        filter={<FilterC5Transactions />}
        actions={[
          {
            label: "actions.new",
            route: `${client}/${table_name}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
